import { FormEvent } from 'react';
import type { Company } from '../../types/company';
import { formatCNPJ, formatPhone, formatCEP } from '../../types/api';
import { Form, FormField, FormLabel, FormInput, Button } from '../ui';
import { FormCpfCnpj, FormPhone, FormMail } from '../ui/FormControls';

interface CompanyFormProps {
  company: Company | null;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onClose: () => void;
  validationErrors: Record<string, string>;
}

function CompanyForm({
  company,
  onSubmit,
  isLoading,
  onClose,
  validationErrors,
}: CompanyFormProps) {
  return (
    <Form onSubmit={onSubmit}>
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-6 mb-6">
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4 flex items-center">
          <span className="bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 p-1.5 rounded-lg mr-2">
            Empresa
          </span>
          Dados da Empresa
        </h3>

        <FormField>
          <FormLabel htmlFor="cnpj" required>
            CNPJ
          </FormLabel>
          <FormCpfCnpj
            id="cnpj"
            name="cnpj"
            type="cnpj"
            value={company?.cnpj ? formatCNPJ(company.cnpj) : ''}
            onChange={() => {}}
            required
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="company_name" required>
            Nome da Empresa
          </FormLabel>
          <FormInput
            id="company_name"
            name="company_name"
            defaultValue={company?.company_name}
            required
          />
        </FormField>
      </div>

      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-6 mb-6">
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4 flex items-center">
          <span className="bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 p-1.5 rounded-lg mr-2">
            Contato
          </span>
          Informações de Contato
        </h3>

        <div className="grid grid-cols-2 gap-4">
          <FormField>
            <FormLabel htmlFor="phone">Telefone</FormLabel>
            <FormPhone
              id="phone"
              name="phone"
              value={company?.phone ? formatPhone(company.phone) : ''}
              onChange={() => {}}
            />
          </FormField>

          <FormField>
            <FormLabel htmlFor="email">Email</FormLabel>
            <FormMail id="email" name="email" value={company?.email || ''} onChange={() => {}} />
          </FormField>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-6">
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4 flex items-center">
          <span className="bg-purple-100 dark:bg-purple-900 text-purple-700 dark:text-purple-300 p-1.5 rounded-lg mr-2">
            Endereço
          </span>
          Informações de Endereço
        </h3>

        <FormField>
          <FormLabel htmlFor="address">Endereço</FormLabel>
          <FormInput id="address" name="address" defaultValue={company?.address} />
        </FormField>

        <FormField className="mt-4">
          <FormLabel htmlFor="city">Cidade</FormLabel>
          <FormInput id="city" name="city" defaultValue={company?.city} />
        </FormField>
      </div>

      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button type="submit" isLoading={isLoading} className="sm:col-start-2">
          {company ? 'Salvar' : 'Criar'}
        </Button>
        <Button type="button" variant="secondary" onClick={onClose} className="sm:col-start-1">
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default CompanyForm;
